import _ from 'underscore';
import * as putil from '@bingads-webui-universal/primitive-utilities';

let Permissions;

export function initialize({
  globalConfig,
}) {
  Permissions = globalConfig.get('Permissions');
}


export function enableForAudienceSOVFeatures(schema) {
  const schemaName = schema.name;
  const schemaNameWhiteList = ['Account', 'Campaign', 'AdGroup'];
  let propNameBlackList = [
    'AudienceAuctionWonPercent',
    'AudienceTopISLostToBudgetPercent',
    'AudienceTopISLostToRankPercent',
    'RelativeCTR',
  ];

  if (Permissions.IsAudienceSOVEnabled && _.contains(schemaNameWhiteList, schemaName)) {
    if (schemaName === 'Account') {
      propNameBlackList = [
        'RelativeCTR',
      ];
    } else {
      propNameBlackList = [];
    }
  }

  const performanceMetrics = putil.get(schema, 'properties.PerformanceMetrics');
  const performanceMetricsProperties = putil.get(performanceMetrics, 'schema.properties');
  const audienceSOVMetrics = [
    'AudienceAuctionWonPercent',
    'AudienceTopISLostToBudgetPercent',
    'AudienceTopISLostToRankPercent',
    'RelativeCTR',
  ];

  if (performanceMetricsProperties) {
    // eslint-disable-next-line arrow-body-style
    const columnsToAdd = _.filter(audienceSOVMetrics, (audienceSOVMetric) => {
      return putil.get(performanceMetricsProperties, audienceSOVMetric) &&
      _.contains(schemaNameWhiteList, schemaName) &&
      !_.contains(propNameBlackList, audienceSOVMetric);
    });

    if (_.isArray(performanceMetrics.filterable)) {
      performanceMetrics.filterable = _.chain(performanceMetrics.filterable)
        .union(columnsToAdd)
        .value();
    } else {
      _.each(audienceSOVMetrics, (audienceSOVMetric) => {
        if (_.contains(columnsToAdd, audienceSOVMetric)) {
          // eslint-disable-next-line no-param-reassign
          schema.properties.PerformanceMetrics.schema.properties[audienceSOVMetric].filterable =
          true;
        }
      });
    }
  }

  return schema;
}
